import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { ClipLoader } from 'react-spinners';
import Api from '../../../api/axios';
import { useUserContext } from '../../../context/user_context';
import FetchApi from '../../../api/getAxios';



const Features = (props) => {

    const [load, setload] = useState(false);
    const [feature, setfeature] = useState(false);
    const [sending, setsending] = useState(false);
    const [featureStatus, setFeatureStatus] = useState('');

    const { btoken, stoken } = useUserContext();

    useEffect(() => {
        if (props.work === true) {
            checkForFeature(props.value);
        }
    }, []);

    // Form Fields
    function handleChange(e) {
        confirmF(feature ? false : true);
    }
    // Form Fields

    //  Check feature status
    const checkForFeature = () => {
        setload(true);
        const data = {
            usertoken: props.staff,
            btoken,
            stoken,
            feature: props.value,

        };
        FetchApi.post(`/user.access.check`, data)
            .then((res) => {
                if (res.success === true) {
                    setload(false);
                    setfeature(res.success);
                    setFeatureStatus(res.message);
                } else {
                    setload(false);
                    setfeature(res.success);
                    setFeatureStatus(res.message);
                }
            })
            .catch((error) => {
                if (error.statusCode === 400) {
                    setfeature(error.success);
                    setFeatureStatus(error.message);
                    setload(false);
                }
                setload(false);

            });
    };

    // Add a feature
    function addFeature(e) {
        setsending(true);
        const data = {
            usertoken: props.staff,
            btoken,
            stoken,
            feature: props.value,
        };
        Api.post(`user.access.add`, data)
            .then((res) => {
                if (res.success === true) {
                    setsending(false);
                    toast.success(res.message);
                    setfeature(feature);
                    checkForFeature();
                } else {
                    setsending(false);
                    toast.success(res.message);
                    checkForFeature();
                }
            })
            .catch((error) => {
                setsending(false);
                setfeature(feature);
            });
    }

    // Remove a feature
    function removeFeature(e) {
        setsending(true);
        const data = {
            usertoken: props.staff,
            btoken,
            stoken,
            feature: props.value,
        };
        Api.post(`user.access.remove`, data)
            .then((res) => {
                if (res.success === true) {
                    setsending(false);
                    toast.success(res.message);
                    setfeature(feature);
                    checkForFeature();
                } else {
                    setsending(false);
                    toast.success(res.message);
                    checkForFeature();
                }
            })
            .catch((error) => {
                setsending(false);
                setfeature(feature);
            });
    }

    // Confirm update feature
    function confirmF(e) {
        if (window.confirm(`Are you sure you want to confirm?`)) {
            feature ? removeFeature(e) : addFeature(e);
        }
    }

    return (

        <>
            {load ?
                <ClipLoader color={"#023676"} loading={props.load} speedMultiplier="1.2" />
                : <>
                    {sending ?
                        <ClipLoader color={"#023676"} loading={props.load} speedMultiplier="1.2" /> : <>

                            <label className="col-lg-5 col-md-12 sec-bold pry-bold-text fw-bold p-3 mb-1 mx-1 " for={props.value}>
                                <div className="custom-control custom-radio mb-2 text-break">
                                    <input
                                        type="checkbox"
                                        className="custom-control-input"
                                        name={props.value}
                                        id={props.value}
                                        value={props.value}
                                        onChange={e => handleChange(e)}
                                        checked={feature ? true : false}

                                    />
                                    <label className="custom-control-label ms-2" for={props.value}>
                                        <span className="text-uppercase">
                                            {props.name}
                                        </span>
                                    </label> <br />
                                    <small className='fw-light'> {featureStatus} </small>
                                </div>
                            </label>

                        </>}

                </>}


        </>
    )
        ;
};

export default Features;



